import { Button } from "flowbite-react";
import React from 'react';
import { Link } from 'react-router-dom';
import { baseUrl } from '../config';



export function PromotionsContent() {
  return (
    <div className='p-3'>
      <h3 className='font-bold pb-3'>Promotions</h3>
      <p>
      Promote your latest production with stunning, AI-generated posters and marketing materials.
       Our AI design tool crafts visually captivating ads and posters that align with your production’s theme, 
       tone, and target audience, ensuring your project makes a powerful first impression.
      </p>
      <p className="mt-3">Why Choose Us?</p>
      <ol>
        <li>Experienced Team: We work with directors, writers, and crews that have been a part of award-winning productions.</li>
        <li>End-to-End Services: From concept development to final cut, we handle every aspect of production.</li>
        <li>Latest Technology: We use cutting-edge equipment and software to deliver results that exceed expectations.</li>
      </ol>
      <Link to='/promotions'><p className='text-blue-600 underline mt-4 cursor-pointer'>Learn more</p></Link>
      <Button color='dark' className="mt-4">No thanks, take me to the page</Button>
    </div>
  );
}
